// extracted by mini-css-extract-plugin
export var icon = "LinkBlock-module--icon--24c49";
export var root = "LinkBlock-module--root--ad3a0";